module.exports = __webpack_public_path__ + "img/MENU_TODOS_DEPARTAMENTOS.2dc5bf87.png";